import baoYueDaidaijiaLogo from '@imgs/baoYue-daidaijia.png'
import shenfutongDomainLogo from '@imgs/shenfutong-domain-logo.png'
import youqianqianbaoLogo from '@imgs/youqianqianbao-logo.png'
import { CompanyType } from '@/constants/common'

export interface DomainBranding {
  appName: string
  companyName: string
  filing: string
  logo: string
  appType: number
  logoText: string
  favicon: string
  enableAppDownload: boolean
}

export const DEFAULT_DOMAIN_BRANDING: DomainBranding = {
  appName: '有钱钱包',
  companyName: CompanyType.YQQB_COMPANY.company,
  filing: `${CompanyType.YQQB_COMPANY.recordNumber}-1`,
  logo: youqianqianbaoLogo,
  appType: 1,
  logoText: 'youqianqianbao-text',
  favicon: 'youqianqianbao-favicon.ico',
  enableAppDownload: true,
}

export const DOMAIN_BRANDING_MAP: Record<string, DomainBranding> = {
  'yql-h5.beyondfin.cn': {
    appName: '贷贷嘉',
    companyName: '北京宝越融资担保有限公司',
    filing: '京ICP备2025104295号-1',
    logo: baoYueDaidaijiaLogo,
    appType: 1,
    logoText: 'daidaijia-text-logo',
    favicon: 'baoYue-daidaijia.ico',
    enableAppDownload: false,
  },
  'yql-h5.cdcy.cc': {
    appName: '神付通',
    companyName: CompanyType.CDCY_COMPANY.company,
    filing: `${CompanyType.CDCY_COMPANY.recordNumber}-1`,
    logo: shenfutongDomainLogo,
    appType: 1,
    logoText: 'shenfutong-text-logo',
    favicon: 'shenfutong-domain.ico',
    enableAppDownload: false,
  },
}

export const getDomainBrandingByHostname = (hostname?: string) => {
  if (!hostname) {
    return DEFAULT_DOMAIN_BRANDING
  }

  return DOMAIN_BRANDING_MAP[hostname] || DEFAULT_DOMAIN_BRANDING
}
